<template>
  <v-row>
    <v-col cols="12" v-for="(item, i) in localTrainingCertificateParent.list" :key="i">
      <TrainingCertificateDocComponent
        :index="i"
        :item="item"
        @set-data="setTrainingCertificate($event, item)"
        @remove="removeTrainingCertificate(item)"
      />
    </v-col>

    <v-col
      cols="12"
      class="d-flex justify-end pt-0"
      v-if="!localTrainingCertificateParent.list.length"
    >
      <v-btn
        color="primary"
        outlined
        rounded
        @click="addTrainingCertificate"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        Добавить справку об обучении
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import TrainingCertificateDocComponent from '@/components/zvp/application-create/training-certificate-doc/TrainingCertificateDoc'
import {TrainingCertificateParent, TrainingCertificate} from '@/models'
import _cloneDeep from "lodash/cloneDeep";

export default {
  name: "TrainingCertificateDoc",

  components: {
    Title,
    TrainingCertificateDocComponent
  },

  props: {
    item: TrainingCertificateParent
  },

  data: () => ({
    localTrainingCertificateParent: new TrainingCertificateParent(),
  }),

  computed: {},

  methods: {
    addTrainingCertificate() {
      this.localTrainingCertificateParent.list.push(new TrainingCertificate())
    },

    setTrainingCertificate(event, item) {
      item.setProperties(event)
      this.$emit('set-data', this.localTrainingCertificateParent)
    },

    removeTrainingCertificate(item) {
      this.$emit('remove', item)
      //this.localTrainingCertificateParent.remove(item)
    },
  },

  watch: {
    'item.list': {
      immediate: true,
      deep: true,
      handler(value) {
        this.localTrainingCertificateParent = _cloneDeep(this.item)
        if (!value?.length) this.addTrainingCertificate()
      }
    }
  }
}
</script>

<style scoped>
</style>
